export class CartaceoVO {
  dug: string;
  indirizzo: string;
  numeroCivico: string;
  comune: string;
  codiceIstat: string;
  provincia: string;
  esteroCitta: string;
  esteroProvincia: string;
  cap: string;
  nazione: string;
}
